import React, { useState } from "react";
import styles from "./ratings.module.css";
import {
  DropDown,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { Col, List, Rate, Row } from "antd";
import { AiFillStar } from "react-icons/ai";
import Modal from "../../../../../components/modal/Modal";
import { BsStarFill } from "react-icons/bs";
import avatar from "../../../../../assets/avatar-3.png";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import {ReviewMiddleware} from '../../../../../Store/Middlewares/ReviewMiddleware'
import { useNavigate } from "react-router-dom";
const desc = ["Give Rating", "Terrible", "Bad", "Average", "Good", "Wonderful"];
const tooltip = ["Terrible", "Bad", "Average", "Good", "Wonderful"];

const services = [
  "Weeding Photographer",
  "Engagement Photographer",
  "Portrait Photographer",
  "Event Photographer",
];

const ratings = [
  {
    img: avatar,
    name: "James Steve",
    rating: 4.1,
    comment:
      "Leif Floyd Photography is a professional photography studio specializing in capturing stunning moments and memories. With a keen eye for detail and a passion for storytelling, Leif Floyd creates visually captivating images that reflect the essence and emotions of weddings, engagements, and other special occasions.",
  },
  {
    img: avatar,
    name: "James Steve",
    rating: 4.1,
    comment:
      "Leif Floyd Photography is a professional photography studio specializing in capturing stunning moments and memories. With a keen eye for detail and a passion for storytelling, Leif Floyd creates visually captivating images that reflect the essence and emotions of weddings, engagements, and other special occasions.",
  },
];

const renderReviews = (item) => {
  return (
    <>
      <Row className={styles.mainCont}>
        <div className={styles.headLeftCont}>
          {/* <img src={item?.vendor_image} alt="" /> */}
          <TextComponent text={item?.user_name} textClass={styles.textHeading} />
        </div>
        {/* <Col className={styles.rateCont}> */}
        {item?.type == "Review" ? 
        <Row className={styles.rateCont}>
          <TextComponent text={`Rating ${item?.rating}`} textClass={styles.textHeading} />
          <AiFillStar size={25} color="#FFD600" />
        </Row>
        : null}
        {/* </Col> */}
      </Row>
      <TextComponent
        text={
          item?.review
        }
        textClass={styles.servText}
      />
    </>
  );
};

function Ratings({details}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [type, setType] = useState("Select Type");
  const [Feedback, setFeedback] = useState("");
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onPressSubmitReview = () => {
    if (type == 'Select Type') {
        dispatch(showAlert({type: "Error", message: 'Please select type' }))
    } else if (!Feedback) {
        dispatch(showAlert({type: "Error", message: 'Please write your review' }))
    } else {
        let data = {
            vendor_id: details?.id,
            type: type,
            feedback: Feedback,
            rating: value
        }
        dispatch(ReviewMiddleware.submitReview(data))
            .then(() => { navigate(-1)
            setIsModalOpen(false)
            })
            .catch(err => console.log(err))

    }
}
  return (
    <>
      <div className={styles.mainDiv}>
        {details?.is_already_joined ? 
        <TextComponent
          textClass={styles.reviewText}
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <svg
            className={styles.reviewIcon}
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M37.6797 0.21875H4.34635C2.04427 0.21875 0.200521 2.08333 0.200521 4.38542L0.179688 41.8854L8.51302 33.5521H37.6797C39.9818 33.5521 41.8464 31.6875 41.8464 29.3854V4.38542C41.8464 2.08333 39.9818 0.21875 37.6797 0.21875ZM8.51302 25.2188V20.0625L22.8464 5.72917C23.2526 5.32292 23.9089 5.32292 24.3151 5.72917L28.0026 9.41667C28.4089 9.82292 28.4089 10.4792 28.0026 10.8854L13.6693 25.2188H8.51302ZM33.513 25.2188H17.888L22.0547 21.0521H33.513V25.2188Z" />
          </svg>
          <text>Write A Review</text>
        </TextComponent>
        : null}
        <List
          className={styles.list}
          itemLayout="vertical"
          dataSource={details?.rating}
          renderItem={renderReviews}
        />
      </div>
      <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        className={styles.modal}
      >
        <Row className={styles.feedbackHeading}>
          <TextComponent text={"Feedback"} textClass={styles.textHeading} />
        </Row>
        <div style={{ position: "relative" }}>
          <DropDown
            placeholder={"Review"}
            name={"role"}
            selectedValue={type}
            label={"Select Type"}
            onChange={setType}
            options={[
              { value: "Review", option: "Review" },
              { value: "Complaint", option: "Complaint" },
              { value: "Suggestion", option: "Suggestion" },
            ]}
          />
        </div>
        <Row>
          <label className={styles.label}>Message Box</label>
          <textarea
            className={styles.textArea}
            placeholder={`Write Your ${type == "Select Type" ? "Review" : type}`}
            cols="30"
            rows="5"
            value={Feedback}
            onChange={(e) => setFeedback(e.target.value)}
          />
        </Row>
        {type == "Review" ? (
          <Col className={styles.rateContModal}>
            <Row>
              <TextComponent
                text={desc[value.toFixed()]}
                textClass={styles.textHeading}
              />
            </Row>
            <Row>
              <Rate
                style={{ color: "#FBB230" }}
                tooltips={tooltip}
                // allowHalf
                onChange={setValue}
                value={value}
                character={(props) => {
                  console.log(props);
                  return (
                    <BsStarFill
                      size={35}
                      style={{ stroke: "#FBB230", strokeWidth: "1px" }}
                    />
                  );
                }}
              />
            </Row>
            <Row>
              <TextComponent text={value} textClass={styles.textHeading} />
            </Row>
          </Col>
        ) : null}
        <SubmitButton
          title={"Submit"}
          btnClass={styles.submitBtn}
          onClick={onPressSubmitReview}
        />
      </Modal>
    </>
  );
}

export default Ratings;
